import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Container } from './styles';
import ReactDOM from 'react-dom';
// user defined hooks
import useContextMenu from './utils';

// layer menu to control positioning
import LayerMenu from './LayerMenu';
import { PageElementsContext } from '../../context/pageElementsContext';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { COMPLEX_DOCUMENT_CONTEXT_KEYS, useDocumentContext } from '../../context/complexDocumentContext';

const ContextMenu = ({
  documentId,
  scaling,
  multiSelectedElementIds,
  setSelectedElementIds,
  swapElements,
  handleModal,
  showSave,
  generateTextHandler,
  textBlock,
  assignVariableHandler,
  staticTable,
  isHeaderElement = false,
  isStaticTableBlock = false,
  groupingElements,
  flowId,
}) => {
  const [elementJson, setElementJson] = useState([]);

  const noVariablesDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN] || store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [disableVariables] = useArtboardContext(noVariablesDesignSelector, `ImageEditor`);

  const { xPos, yPos, transform, elementId, showMenu, element, showMultiElementsMenu, setShowMenu, isSingleElementOfGroupSelected } = useContextMenu(
    documentId,
    scaling,
    multiSelectedElementIds,
    textBlock,
    staticTable,
    disableVariables
  );
  const { storedElements, groupedElementIds } = useContext(PageElementsContext);

  useEffect(() => {
    if (showMenu) {
      if (showMultiElementsMenu) {
        // elements json construction for multiple elements goes here
        let elementsToSave = storedElements.filter(element => {
          return (
            multiSelectedElementIds.includes(element.uuid)
            // &&
            // element.elementDetails.type !== 'table' &&
            // element.elementDetails.type !== 'referenced'
          );
        });
        setElementJson(elementsToSave);
      } else {
        // elements json construction for single element goes here
        let target = Array.from(storedElements).filter(el => el.uuid === elementId);
        setElementJson(target[0]);
      }
    }
  }, [storedElements, elementId, showMenu, showMultiElementsMenu, multiSelectedElementIds]);

  const [editorRef, updateArtboard] = useArtboardContext(store => store[CONTEXT_KEYS.TEXT_ELEMENT_REF],);
  const isEmailSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_EMAIL_TEMPLATE], []);
  const [isEmail] = useDocumentContext(isEmailSelector, 'ContextMenu');
  const { groupName, setGroupName } = useContext(PageElementsContext);

  const enableTocSettings = useCallback(() => {
    if (!isHeaderElement) {
      const editor = editorRef?.current?.getEditor();
      editor.focus();
      const range = editor.getSelection();
      const quillSelectedText = editor.getText(range.index, range.length);

      if (quillSelectedText.length > 0) {
        updateArtboard({ [CONTEXT_KEYS.TOC_MODAL_INFO]: { selectedText: quillSelectedText } });
      }
    }
  }, [editorRef, elementId]);

  const handleGroupNameSave = useCallback((type, value) => {
    setGroupName(value);
    groupingElements(type, groupedElementIds, value);
  });

  const showBusinessLogicModal = useCallback(() => {
    updateArtboard({
      [CONTEXT_KEYS.BUSINESS_LOGIC_MODAL]: { logicType: 'element', groupName: groupName, flowId: flowId, onGroupSave: handleGroupNameSave },
      [CONTEXT_KEYS.GROUPED_ELEMENT_IDS]: groupedElementIds,
      [CONTEXT_KEYS.CURRENT_BLOCK_ID]: documentId,
    });
  });

  const renderMenu = () => {
    return (
      <Container
        className="menu-container"
        style={{
          top: yPos,
          left: xPos,
          transform: transform || undefined,
        }}
      >
        <LayerMenu
          swapElements={swapElements}
          element={element}
          elementJson={elementJson}
          elementId={elementId}
          handleModal={handleModal}
          showMenu={showMenu}
          showMultiElementsMenu={showMultiElementsMenu}
          showSave={showSave}
          showGenerateText={editorRef?.current?.getEditor().getSelection()?.length > 0}
          generateTextHandler={generateTextHandler}
          assignVariableHandler={assignVariableHandler}
          textBlock={textBlock}
          setShowMenu={setShowMenu}
          staticTable={staticTable}
          enableToc={enableTocSettings}
          enableBusinessLogic={showBusinessLogicModal}
          isHeaderElement={isHeaderElement ? isHeaderElement : isEmail}
          isStaticTableBlock={isStaticTableBlock}
          groupingElements={groupingElements}
          multiSelectedElementIds={multiSelectedElementIds}
          blockId={documentId}
        />
      </Container>
    );
  };

  return (
    <>
      {showMenu
        ? ReactDOM.createPortal(
            renderMenu(),
            multiSelectedElementIds?.length > 1 && flowId && document.getElementById(`context-menu-container-${flowId}`)
              ? document.getElementById(`context-menu-container-${flowId}`)
              : document.body,
          )
        : null}
    </>
  );
};

export default ContextMenu;
